
import { Vue } from 'vue-property-decorator';
export default class StartTestPanel extends Vue {
  private handleClick(): void {
    this.$emit('startButtonClicked');
  }
}
